import { useState, useEffect } from 'react'
import { type RecordNavigationResult } from 'interfaces/navigation'

export type { RecordNavigationResult }

export function useRecordNavigation (
  fetchFn: (id: number) => Promise<RecordNavigationResult>,
  currentId: number
): RecordNavigationResult & { loading: boolean } {
  const [previousId, setPreviousId] = useState<number | null>(null)
  const [nextId, setNextId] = useState<number | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    void fetchFn(currentId).then((result) => {
      if (!cancelled) {
        setPreviousId(result.previousId)
        setNextId(result.nextId)
        setLoading(false)
      }
    }).catch(() => {
      if (!cancelled) {
        setLoading(false)
      }
    })
    return () => {
      cancelled = true
    }
  }, [currentId, fetchFn])

  return { previousId, nextId, loading }
}
